// extracted by mini-css-extract-plugin
export default {"container":"form-input_container__7axJG","input":"form-input_input__pbJMS","label":"form-input_label__CBUx9"};